import { ICountry } from 'models';
import { Moment } from 'moment';
import { Scope, SubscriptionStatus } from 'redux/reducers/authReducer';
import { Bank } from './bank';

export enum OrganizationType {
  SoleTrader = 'SoleTrader',
  Partnership = 'Partnership',
  Company = 'Company',
}

export enum OrganizationReferralStatus {
  Pending = 'Pending',
  Paid = 'Paid',
}

export interface OrganizationReferral {
  referee: {
    name: string;
  };
  status: OrganizationReferralStatus;
  createdAt: Moment;
}

export interface Organization {
  id: string;
  name: string;
  email: string;
  organizationType: OrganizationType;
  isGstRegistered: boolean;
  country: ICountry;
  idCountry: string;
  timezone: string;
  phoneNumber?: string;
  addressLine1?: string;
  addressLine2?: string;
  abn?: string;
  paymentTerms: number;
  invoicePrefix?: string;
  bankName?: Bank;
  bankNameOther?: string;
  bankBsb?: string;
  bankAccountNumber?: string;
  referralCode: string;
  subscriptionStatus?: SubscriptionStatus;
  createdAt: Moment;
  trialEndDate: Moment;
  // FIXME: Add more properties here later

  // Display only
  invitationCode?: string;
}

// TODO: Delete this shortly
export interface IRole {
  id: string;
  idOrganization: string;
  name: string;
  description: string;
  permissions: Scope[];
  isDefault: boolean;
  createdAt: Moment;
  updatedAt: Moment;
}

// TODO: Add the Role enum here
